import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { useHistory } from 'react-router';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';

import { RoutePath } from '@components/AppRouter/constants';
import { usePermission } from '@src/utils/hooks/usePermission';
import { controlGroupEditStore } from '@stores/dictionaryStores/controlGroupsStore/controlGroupEditStore';

import { NEW_ENTITY_ID } from '../../../../AppRouter/hooks/constants';
import { FormWithActions } from '../../../FormWithActions';

import styles from './Form.module.scss';

export const Form = observer(() => {
  const { isEditMode, isNew } = controlGroupEditStore;

  const { push } = useHistory();

  const cmControlPermission = usePermission('CmControl');

  const {
    input: { value: ctrlGroupCode },
  } = useField('ctrlGroupCode');

  const onCreateControl = useCallback(() => {
    push(`${RoutePath.DICTIONARY_CONTROLS}/${NEW_ENTITY_ID}`, { ctrlGroupCode });
  }, [ctrlGroupCode, push]);

  const onGoControls = useCallback(() => {
    push(RoutePath.DICTIONARY_CONTROLS, { ctrlGroupCode });
  }, [ctrlGroupCode, push]);

  const goToControls = useCallback(() => push(RoutePath.DICTIONARY_CONTROL_GROUPS), [push]);

  return (
    <FormWithActions
      store={controlGroupEditStore}
      goBackLink={goToControls}
      actions={
        <div className={styles.buttons}>
          <Button onClick={onCreateControl} disabled={isNew || !cmControlPermission.CREATE}>
            Создать контроль
          </Button>
          <Button onClick={onGoControls}>Перейти к контролям</Button>
        </div>
      }
    >
      <>
        <TextField
          name="ctrlGroupOrder"
          label="Порядок отображения групп контроля"
          disabled
          size="small"
          groupStyle={!isEditMode}
          required
        />
        <TextField
          name="ctrlGroupCode"
          label="Код группы контролей"
          disabled={!isNew}
          size="small"
          groupStyle={!isEditMode}
          required
          maxLength={30}
        />
        <TextField
          name="ctrlGroupName"
          label="Наименование группы контролей"
          disabled={!isEditMode}
          size="small"
          groupStyle={!isEditMode}
          required
          maxLength={1000}
        />
      </>
    </FormWithActions>
  );
});
